import { PropType } from 'vue';
import { isNil } from 'lodash-es';
import { PERIOD_DAY } from '@/typings/enums/PERIOD_DAY';
import BaseSetupService from '../BaseSetupService';

type Props = SetupProps<typeof UserProfileAvailabilityDaySetupService.props>
type Emits = {(e: 'update:modelValue', val: Number): void}

export default class UserProfileAvailabilityDaySetupService extends BaseSetupService<Props> {
	static readonly props = {
		readonly: Boolean,
		modelValue: {
			type: Number as PropType<PERIOD_DAY>,
			required: true as const,
		},
		day: {
			type: String,
			default: undefined,
		},
		date: {
			type: Date,
			default: undefined,
		},
	};

	private emits: Emits;

	get PERIOD_DAY () { return PERIOD_DAY; }
	get availableMorning () { return (this.props.modelValue & PERIOD_DAY.Morning) === PERIOD_DAY.Morning; }
	get availableAfternoon () { return (this.props.modelValue & PERIOD_DAY.Afternoon) === PERIOD_DAY.Afternoon; }
	get availableNight () { return (this.props.modelValue & PERIOD_DAY.Night) === PERIOD_DAY.Night; }

	get readableDay () {
		let readableDay;
		switch (this.props.day) {
		case 'monday':
			readableDay = this.ui.onLayoutNavBottom ? 'Lun.' : 'Lundi';
			break;
		case 'tuesday':
			readableDay = this.ui.onLayoutNavBottom ? 'Mar.' : 'Mardi';
			break;
		case 'wednesday':
			readableDay = this.ui.onLayoutNavBottom ? 'Mer.' : 'Mercredi';
			break;
		case 'thursday':
			readableDay = this.ui.onLayoutNavBottom ? 'Jeu.' : 'Jeudi';
			break;
		case 'friday':
			readableDay = this.ui.onLayoutNavBottom ? 'Ven.' : 'Vendredi';
			break;
		case 'saturday':
			readableDay = this.ui.onLayoutNavBottom ? 'Sam.' : 'Samedi';
			break;
		case 'sunday':
			readableDay = this.ui.onLayoutNavBottom ? 'Dim.' : 'Dimanche';
			break;
		}

		return readableDay;
	}


	constructor (props: Props, emits: Emits) {
		super(props);
		this.emits = emits;
	}


	handleClick (period: number) {
		if (!this.self.isTempWorker()) return;
		const value = isNil(this.props.modelValue) ? period : this.props.modelValue ^ period;
		this.emits('update:modelValue', value);
	}
}
